import { Box } from "@mui/material";
import InfoRow from "../blocks/InfoRowHeader";
import { useTranslation } from "react-i18next";

import { capitalizeWords, formatCnpj } from "../../../src/utilities/Utilities";

const CteHeaderInfo = ({ headerInfo }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: 4,
      }}
    >
      <Box>
        <InfoRow label={t("columns.cteNumber")} value={headerInfo.number_cte} />
        <InfoRow label={t("columns.natOp")} value={headerInfo.nat_op} />
      </Box>

      <Box>
        <InfoRow label={t("columns.carrierName")} value={capitalizeWords(headerInfo.carrier_name)} />
        <InfoRow label={t("columns.carrierCnpj")} value={formatCnpj(headerInfo.carrier_cnpj)} />
      </Box>

      <Box>
        <InfoRow label={t("columns.destName")} value={capitalizeWords(headerInfo.recipient_name)} />
        <InfoRow label={t("columns.destCnpj")} value={formatCnpj(headerInfo.recipient_cnpj)} />
      </Box>
    </Box>
  );
};

export default CteHeaderInfo;
